import SgiBadgeEO from "../sgiCompEO/SgiBadgeEO";
import { SgiButtonEO } from "../sgiCompEO/SgiButtonEO";
import { SgiCalendarEO } from "../sgiCompEO/SgiCalendarEO";
import { SgiColEO } from "../sgiCompEO/SgiColEO";
import { SgiCollapseEO } from "../sgiCompEO/SgiCollapseEO";
import { SgiCommEchartsEO } from "../sgiCompEO/SgiCommEchartsEO";
import { SgiDVEO } from "../sgiCompEO/SgiDVEO";
import { SgiEChartsCommonEO } from "../sgiCompEO/SgiEChartsCommonEO";
import { SgiFormCascaderEO } from "../sgiCompEO/SgiFormCascaderEO";
import { SgiFormCheckboxEO } from "../sgiCompEO/SgiFormCheckboxEO";
import { SgiFormCheckboxGroupEO } from "../sgiCompEO/SgiFormCheckboxGroupEO";
import { SgiFormComboboxEO } from "../sgiCompEO/SgiFormComboboxEO";
import { SgiFormComboxTreeEO } from "../sgiCompEO/SgiFormComboxTreeEO";
import { SgiFormDateEO } from "../sgiCompEO/SgiFormDateEO";
import { SgiFormEditorEO } from "../sgiCompEO/SgiFormEditorEO";
import { SgiFormEO } from "../sgiCompEO/SgiFormEO";
import { SgiFormFileEO } from "../sgiCompEO/SgiFormFileEO";
import { SgiFormInputNumberEO } from "../sgiCompEO/SgiFormInputNumberEO";
import { SgiFormPopUIEO } from "../sgiCompEO/SgiFormPopUIEO";
import { SgiFormRadioEO } from "../sgiCompEO/SgiFormRadioEO";
import { SgiFormTextAreaEO } from "../sgiCompEO/SgiFormTextAreaEO";
import { SgiFormTextEO } from "../sgiCompEO/SgiFormTextEO";
import { SgiFormTimeEO } from "../sgiCompEO/SgiFormTimeEO";
import SgiG6CommonEO from "../sgiCompEO/SgiG6CommonEO";
import { SgiImgEO } from "../sgiCompEO/SgiImgEO";
import SgiJsoneditorEO from "../sgiCompEO/SgiJsoneditorEO";
import { SgiLabelEO } from "../sgiCompEO/SgiLabelEO";
import { SgiTagEO } from "../sgiCompEO/SgiTagEO";
import { SgiListEO } from "../sgiCompEO/SgiListEO";
import { SgiMenuEO } from "../sgiCompEO/SgiMenuEO";
import { SgiNestEO } from "../sgiCompEO/SgiNestEO";
import { SgiOverlapEO } from "../sgiCompEO/SgiOverlapEO";
import { SgiPanelEO } from "../sgiCompEO/SgiPanelEO";
import { SgiQuoteEO } from "../sgiCompEO/SgiQuoteEO";
import { SgiRowEO } from "../sgiCompEO/SgiRowEO";
import SgiSpinEO from "../sgiCompEO/SgiSpinEO";
import { SgiSplitterEO } from "../sgiCompEO/SgiSplitterEO";
import { SgiStepsEO } from "../sgiCompEO/SgiStepsEO";
import { SgiTableEO } from "../sgiCompEO/SgiTableEO";
import { SgiTabsEO } from "../sgiCompEO/SgiTabsEO";
import { SgiTileEO } from "../sgiCompEO/SgiTileEO";
import { SgiTinyMCEEO } from "../sgiCompEO/SgiTinyMCEEO";
import { SgiToolbarEO } from "../sgiCompEO/SgiToolbarEO";
import SgiTooltipEO from "../sgiCompEO/SgiTooltipEO";
import { SgiTransferEO } from "../sgiCompEO/SgiTransferEO";
import { SgiTreeEO } from "../sgiCompEO/SgiTreeEO";
import { SgiTVEO } from "../sgiCompEO/SgiTVEO";


const AllCompGUID = {
	//UI部分
	UCV: "EP_EO_UI_0001",
	PANEL: "EP_EO_UI_4001",
	PANEL_PURE: "EP_EO_UI_40012",
	WV: "EP_EO_UI_4002",
	DU: "EP_EO_UI_4003",
	MENU: "EP_EO_UI_4004",
	QUOTE: 'EP_EO_UI_4005', //wzhe 2018.5.29 添加，组件的引用 
	SPIN: "EP_EO_UI_4006",
	CARD_PURE: "EP_EO_UI_4007",
	TOOLTIP: "EP_EO_UI_4008",
	BADGE: "EP_EO_UI_4009",
	SPLITTER: "EP_EO_UI_4101",
	TAB: "EP_EO_UI_4102",
	CARD: "EP_EO_UI_4103",
	// OVERPANEL: "EP_EO_UI_4103",
	OVERLAP: "EP_EO_UI_41032",
	ACCORDION: "EP_EO_UI_4104",
	FIELDSET: "EP_EO_UI_4105",
	NEST: "EP_EO_UI_4106",
	//TPL : "EP_EO_UI_4107",    

	LABEL: "EP_EO_UI_3002",
	BUTTON: "EP_EO_UI_3003",
	BUTTON_PURE: "EP_EO_UI_30032",
	IMG: "EP_EO_UI_3004",
	ICON: "EP_EO_UI_3005",
	PROGRESSBAR: "EP_EO_UI_3006",
	TREE: "EP_EO_UI_3007",
	TABLE: "EP_EO_UI_3008",
	AMOUNTTEXT: "EP_EO_UI_3009",
	MONETARYTEXT: "EP_EO_UI_3009",
	TOOLBAR: "EP_EO_UI_3010",
	POPUI: "EP_EO_UI_3011",
	EDITOR: "EP_EO_UI_3012",
	STATBUTTON: "EP_EO_UI_3013",
	STEP: "EP_EO_UI_3015",
	TBFILL: "EP_EO_UI_3016",
	TRANSFER: "EP_EO_UI_3017",
	TAG: "EP_EO_UI_3018",

	//表单组件
	FIELDTEXT: "EP_EO_UI_3101",
	TEXTAREA: "EP_EO_UI_3102",
	FILE: "EP_EO_UI_3103",
	NUMBER: "EP_EO_UI_3104",
	TIME: "EP_EO_UI_3105",
	DATE: "EP_EO_UI_3106",
	COMBOBOX: "EP_EO_UI_3107",
	COMBOXTREE: 'EP_EO_NUI_0001',
	COMBOXGRID: 'EP_EO_NUI_0002',
	CHECKBOXGROUP: "EP_EO_UI_3108",
	RADIOGROUP: "EP_EO_UI_3109",
	CHECKBOX: "EP_EO_UI_3110",
	COLOR: "EP_EO_UI_3111",
	FONT: "EP_EO_UI_3112",
	PASSWORD: "EP_EO_UI_3113",
	EDITORAREA: "EP_EO_UI_3114",
	FIELDDISPLAY: "EP_EO_UI_3115",
	COMPONENT: "EP_EO_UI_3116",
	CONTAINER: "EP_EO_UI_3117",
	UPLOADFILE: "EP_EO_UI_3118",
	MONETARY2TEXT: "EP_EO_UI_3119",
	CASCADER: "EP_EO_UI_3122",
	CODEMIRROR_FORM: "EP_EO_UI_3123",
	LINE: "EP_EO_UI_7001",
	AREA: "EP_EO_UI_7002",
	BAR: "EP_EO_UI_7003",
	SCATTER: "EP_EO_UI_7004",
	PIE: "EP_EO_UI_7005",
	GAUGE: "EP_EO_UI_7006",
	RADAR: "EP_EO_UI_7007",
	/***add by zuan ***/
	LIST: "EP_EO_UI_4107",
	AUDIO: "EP_EO_UI_4108",
	VIDEO: "EP_EO_UI_4109",
	CAROUSEL: "EP_EO_UI_4110",
	NESTEDLIST: "EP_EO_UI_4111",    //嵌套列表控件
	EMAIL: "EP_EO_UI_4112",   //email地址
	SEARCH: "EP_EO_UI_4113",   //搜索控件
	TOGGLE: "EP_EO_UI_4114",    //切换控件
	DVPANEL: "EP_EO_UI_3014",  //DVpanel控件
	FLOATWINDOW: "EP_EO_UI_3120",  //浮动窗口
	PASSWORDSTRENGTH: "EP_EO_UI_3121",  //密码强度控件
	ITEM: "EP_EO_UI_6004",//菜单项
	DIVCOMBOBOX: "EP_EO_NUI_0003",//自定义下拉窗

	//布局
	LT_COLUMN: "EP_EO_UI_5001",
	LT_FIT: "EP_EO_UI_5002",
	LT_TABLE: "EP_EO_UI_5003",
	LT_VBOX: "EP_EO_UI_5004",
	LT_HBOX: "EP_EO_UI_5005",
	LT_ANCHOR: "EP_EO_UI_5006",
	//2018.3.14追加新布局PC端
	LT_ROW: "EP_EO_UI_5101",
	LT_COL: "EP_EO_UI_5102",

	//打印部分
	PTROOT: "EP_EO_PT_0001",
	PTGROUP: "EP_EO_PT_0003",
	PTTEXT: "EP_EO_PT_2001",
	PTTABLE: "EP_EO_PT_3001",
	PTTABLEHEADER: "EP_EO_PT_3101",
	PTTABLEBODY: "EP_EO_PT_3102",
	PTTABLEFOOTER: "EP_EO_PT_3103",

	// 高级组件
	Tile: "EP_EO_UI_SgiTile",
	CommEcharts: "EP_EO_UI_SgiCommEcharts",

	// 新增组件
	Calendar: "EP_EO_UI_SgiCalendar",
	TINYMCE: "EP_EO_UI_TinyMCE",
	CODEMIRROR: "EP_EO_UI_CODEMIRROR",
	JSONEDITOR: "EP_EO_UI_JSONEDITOR",

	// ECharts
	EC_COMMON: "EP_EO_UI_EC0001",

	// G6
	G6_COMMON: "EP_EO_UI_G60001",

	DV: "EP_EO_UI_DV",
	TV: "EP_EO_UI_TV",
};

let getTypeName = function (guid) {
	for (var key in AllCompGUID) {
		if (guid === AllCompGUID[key]) {
			return key;
		}
	}
}


/**
 * 注意：
 * _type: 非实际组件的组件类型，而是拖拽组件的类型，ctn--该组件内部可拖入其他组件、ctl--该组件内部不可拖入其他组件
 * dndCompKey: 拖拽组件key
 * dndCompRef: 拖拽组件内部使用组件的ref
 * dndCompExp: (选填)拖拽组件描述
 * dndCompEKey: (选填)拖拽组件使用描述编辑页面key，默认dndCompKey+"Editor"
 * dndCompEditor: 拖拽组件使用描述编辑页面组件(dnd模式使用，需要dnd自己转成对应组件)
 * sgiComp: 拖拽组件内部使用组件(组件模式使用，需要comp项目自己转成对应组件)
 * sgiCompEO: 组件获取初始描述方法
 * dndSourceType: (选填)拖拽组件拖拽源类型，默认与dndCompKey相同
 * propsParams: 需要额外传递的属性
 */
const AllDndCompInfo = {
	//UI部分
	// UCV: "EP_EO_UI_0001",
	"EP_EO_UI_0001": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiMainComp",
		dndCompRef: "Dnd_SgiMainComp_SgiMainComp",
		dndCompEditor: "Dnd_SgiMainCompEditor",
		sgiComp: "SgiMainComp",
	},
	"EP_EO_UI_4001": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiPanel",
		dndCompRef: "Dnd_SgiPanel_SgiPanel",
		dndCompEditor: "Dnd_SgiPanelEditor",
		sgiComp: "SgiPanel",
		sgiCompEO: SgiPanelEO
	},
	// WV: "EP_EO_UI_4002",
	"EP_EO_UI_4002": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiForm",
		dndCompRef: "Dnd_SgiForm_SgiForm",
		dndCompEditor: "Dnd_SgiFormEditor",
		sgiComp: "SgiForm",
		sgiCompEO: SgiFormEO,
	},
	// Spin: "EP_EO_UI_4006",
	"EP_EO_UI_4006": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiSpin",
		dndCompRef: "Dnd_SgiSpin_SgiSpin",
		dndCompEditor: "Dnd_SgiSpinEditor",
		sgiComp: "SgiSpin",
		sgiCompEO: SgiSpinEO,
	},
	// Card: "EP_EO_UI_4007",
	// "EP_EO_UI_4007": {
	// 	_type: "ctn",
	// 	dndCompKey: "Dnd_SgiCard",
	// 	dndCompRef: "Dnd_SgiCard_SgiCard",
	// 	dndCompEditor: "Dnd_SgiCardEditor",
	// 	sgiComp: "SgiCard",
	// 	sgiCompEO: SgiCardEO,
	// },
	// Tooltip: "EP_EO_UI_4008",
	"EP_EO_UI_4008": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiTooltip",
		dndCompRef: "Dnd_SgiTooltip_SgiTooltip",
		dndCompEditor: "Dnd_SgiTooltipEditor",
		sgiComp: "SgiTooltip",
		sgiCompEO: SgiTooltipEO,
	},
	// Badge: "EP_EO_UI_4009",
	"EP_EO_UI_4009": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiBadge",
		dndCompRef: "Dnd_SgiBadge_SgiBadge",
		dndCompEditor: "Dnd_SgiBadgeEditor",
		sgiComp: "SgiBadge",
		sgiCompEO: SgiBadgeEO,
	},
	// SPLITTER: "EP_EO_UI_4101",
	"EP_EO_UI_4101": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiSplitter",
		dndCompRef: "Dnd_SgiSplitter_SgiSplitter",
		dndCompExp: "分割组件,请拖入普通面板或FORM",
		dndCompEditor: "Dnd_SgiSplitterEditor",
		sgiComp: "SgiSplitter",
		sgiCompEO: SgiSplitterEO,
		// propsParams: { addSgiSplitterCtlDndInfo }
	},
	// TAB: "EP_EO_UI_4102",
	"EP_EO_UI_4102": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiTabs",
		dndCompRef: "Dnd_SgiTabs_SgiTabs",
		dndCompExp: "tab组件,请拖入普通面板或FORM",
		dndCompEditor: "Dnd_SgiTabsEditor",
		sgiComp: "SgiTabs",
		sgiCompEO: SgiTabsEO,
		// propsParams: { addTabCtlDndInfo }
	},
	// OVERPANEL: "EP_EO_UI_4103",
	"EP_EO_UI_4103": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiCollapse",
		dndCompEKey: "Dnd_SgiOverlapEditor",
		dndCompRef: "Dnd_SgiCollapse_SgiCollapse",
		dndCompExp: "重叠面板为了方便编辑，开发时使用折叠面板显示，请添加普通面板或FORM",
		dndCompEditor: "Dnd_SgiOverlapEditor",
		sgiComp: "SgiCollapse",
		sgiCompEO: SgiOverlapEO,
		// propsParams: { addCollapseCtlDndInfo }
	},
	// ACCORDION: "EP_EO_UI_4104",
	"EP_EO_UI_4104": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiCollapse",
		dndCompRef: "Dnd_SgiCollapse_SgiCollapse",
		dndCompExp: "折叠组件,请拖入普通面板或FORM",
		dndCompEditor: "Dnd_SgiCollapseEditor",
		sgiComp: "SgiCollapse",
		sgiCompEO: SgiCollapseEO,
		// propsParams: { addCollapseCtlDndInfo }
	},
	// NEST: "EP_EO_UI_4106",
	"EP_EO_UI_4106": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiNest",
		dndCompRef: "Dnd_SgiNest_SgiNest",
		dndCompExp: "嵌入面板,不能再拖拽子组件，只能嵌入其他UI",
		dndCompEditor: "Dnd_SgiNestEditor",
		sgiComp: "SgiNest",
		sgiCompEO: SgiNestEO,
	},
	// MENU: "EP_EO_UI_4004",
	"EP_EO_UI_4004": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiMenu",
		dndCompRef: "Dnd_SgiMenu_SgiMenu",
		// dndCompExp: "菜单组件,不能再拖拽子组件，只能嵌入其他UI",
		dndCompEditor: "Dnd_SgiMenuEditor",
		sgiComp: "SgiMenu",
		sgiCompEO: SgiMenuEO,
	},
	//TPL : "EP_EO_UI_4107",    
	// QUOTE: 'EP_EO_UI_4005', //wzhe 2018.5.29 添加，组件的引用 
	"EP_EO_UI_4005": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiQuote",
		dndCompRef: "Dnd_SgiQuote_SgiQuote",
		// dndCompExp: "引用面板,不能再拖拽子组件，只能引用其他组件",
		// dndCompEditor: "Dnd_SgiQuoteEditor",
		sgiComp: "SgiQuote",
		sgiCompEO: SgiQuoteEO,
	},

	// LABEL: "EP_EO_UI_3002",
	"EP_EO_UI_3002": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiLabel",
		dndCompRef: "Dnd_SgiLabel_SgiLabel",
		dndCompEditor: "Dnd_SgiLabelEditor",
		sgiComp: "SgiLabel",
		sgiCompEO: SgiLabelEO,
	},
	"EP_EO_UI_3003": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiButton",
		dndCompRef: "Dnd_SgiButton_SgiButton",
		dndCompEditor: "Dnd_SgiButtonEditor",
		sgiComp: "SgiButton",
		sgiCompEO: SgiButtonEO,
	},
	// IMG: "EP_EO_UI_3004",
	"EP_EO_UI_3004": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiImg",
		dndCompRef: "Dnd_SgiImg_SgiImg",
		dndCompEditor: "Dnd_SgiImgEditor",
		sgiComp: "SgiImg",
		sgiCompEO: SgiImgEO,
	},
	// TREE: "EP_EO_UI_3007",
	"EP_EO_UI_3007": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiTree",
		dndCompRef: "Dnd_SgiTree_SgiTree",
		dndCompEditor: "Dnd_SgiTreeEditor",
		sgiComp: "SgiTree",
		sgiCompEO: SgiTreeEO,
	},
	// TABLE: "EP_EO_UI_3008",
	"EP_EO_UI_3008": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiTable",
		dndCompRef: "Dnd_SgiTable_SgiTable",
		dndCompExp: "表格组件,不能再拖拽子组件，只能嵌入其他UI",
		dndCompEditor: "Dnd_SgiTableEditor",
		sgiComp: "SgiTable",
		sgiCompEO: SgiTableEO,
	},
	// TOOLBAR: "EP_EO_UI_3010",
	"EP_EO_UI_3010": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiToolbar",
		dndCompRef: "Dnd_SgiToolbar_SgiToolbar",
		dndCompExp: "工具条组件,请拖入按钮",
		dndCompEditor: "Dnd_SgiToolbarEditor",
		sgiComp: "SgiToolbar",
		sgiCompEO: SgiToolbarEO,
		// propsParams: { addToolbarCtlDndInfo }
	},
	// POPUI: "EP_EO_UI_3011",
	"EP_EO_UI_3011": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormPopUI",
		dndCompRef: "Dnd_SgiFormPopUI_SgiFormPopUI",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormPopUIEditor",
		sgiComp: "SgiFormInputSearch",
		sgiCompEO: SgiFormPopUIEO,
	},
	// EDITOR: "EP_EO_UI_3012",
	"EP_EO_UI_3012": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormEditorE",
		dndCompEKey: "Dnd_SgiFormEditorEditor",
		dndCompRef: "Dnd_SgiFormEditor_SgiFormEditor",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormEditorEditor",
		sgiComp: "SgiEditor",
		sgiCompEO: SgiFormEditorEO,
	},
	// STEP: "EP_EO_UI_3015",
	"EP_EO_UI_3015": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiSteps",
		dndCompRef: "Dnd_SgiSteps_SgiSteps",
		dndCompExp: "步骤组件,不能再拖拽子组件，只能嵌入其他UI",
		dndCompEditor: "Dnd_SgiStepsEditor",
		sgiComp: "SgiSteps",
		sgiCompEO: SgiStepsEO,
	},
	// TRANSFER: "EP_EO_UI_3017",
	"EP_EO_UI_3017": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiTransfer",
		dndCompRef: "Dnd_SgiTransfer_SgiTransfer",
		dndCompExp: "穿梭框组件,不能再拖拽子组件，只能嵌入其他UI",
		dndCompEditor: "Dnd_SgiTransferEditor",
		sgiComp: "SgiTransfer",
		sgiCompEO: SgiTransferEO,
	},
	// TAG: "EP_EO_UI_3018",
	"EP_EO_UI_3018": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiTag",
		dndCompRef: "Dnd_SgiTag_SgiTag",
		dndCompEditor: "Dnd_SgiTagEditor",
		sgiComp: "SgiTag",
		sgiCompEO: SgiTagEO,
	},

	//表单组件
	// FIELDTEXT: "EP_EO_UI_3101",
	"EP_EO_UI_3101": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormText",
		dndCompRef: "Dnd_SgiFormText_SgiFormText",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormTextEditor",
		sgiComp: "SgiFormText",
		sgiCompEO: SgiFormTextEO,
	},
	// TEXTAREA: "EP_EO_UI_3102",
	"EP_EO_UI_3102": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormTextArea",
		dndCompRef: "Dnd_SgiFormTextArea_SgiFormTextArea",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormTextAreaEditor",
		sgiComp: "SgiFormTextArea",
		sgiCompEO: SgiFormTextAreaEO,
	},
	// NUMBER: "EP_EO_UI_3104",
	"EP_EO_UI_3104": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormNumber",
		dndCompRef: "Dnd_SgiFormNumber_SgiFormNumber",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormNumberEditor",
		sgiComp: "SgiFormInputNumber",
		sgiCompEO: SgiFormInputNumberEO,
	},
	// TIME: "EP_EO_UI_3105",
	"EP_EO_UI_3105": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormTime",
		dndCompRef: "Dnd_SgiFormTime_SgiFormTime",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormTimeEditor",
		sgiComp: "SgiFormTimePicker",
		sgiCompEO: SgiFormTimeEO,
	},
	// DATE: "EP_EO_UI_3106",
	"EP_EO_UI_3106": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormDate",
		dndCompRef: "Dnd_SgiFormDate_SgiFormDate",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormDateEditor",
		sgiComp: "SgiFormDatePicker",
		sgiCompEO: SgiFormDateEO,
	},
	// COMBOBOX: "EP_EO_UI_3107",
	"EP_EO_UI_3107": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormCombobox",
		dndCompRef: "Dnd_SgiFormCombobox_SgiFormCombobox",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormComboboxEditor",
		sgiComp: "SgiFormSelect",
		sgiCompEO: SgiFormComboboxEO,
	},
	// COMBOXTREE: 'EP_EO_NUI_0001',
	"EP_EO_NUI_0001": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormComboxTree",
		dndCompRef: "Dnd_SgiFormComboxTree_SgiFormComboxTree",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormComboxTreeEditor",
		sgiComp: "SgiFormTreeSelect",
		sgiCompEO: SgiFormComboxTreeEO,
	},
	// CHECKBOXGROUP: "EP_EO_UI_3108",
	"EP_EO_UI_3108": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormCheckboxGroup",
		dndCompRef: "Dnd_SgiFormCheckboxGroup_SgiFormCheckboxGroup",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormCheckboxGroupEditor",
		sgiComp: "SgiFormCheckboxGroup",
		sgiCompEO: SgiFormCheckboxGroupEO,
	},
	// RADIOGROUP: "EP_EO_UI_3109",
	"EP_EO_UI_3109": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormRadio",
		dndCompRef: "Dnd_SgiFormRadio_SgiFormRadio",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormRadioEditor",
		sgiComp: "SgiFormRadio",
		sgiCompEO: SgiFormRadioEO,
	},
	// CHECKBOX: "EP_EO_UI_3110",
	"EP_EO_UI_3110": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormCheckbox",
		dndCompRef: "Dnd_SgiFormCheckbox_SgiFormCheckbox",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormCheckboxEditor",
		sgiComp: "SgiFormCheckbox",
		sgiCompEO: SgiFormCheckboxEO,
	},
	// UPLOADFILE: "EP_EO_UI_3118",
	"EP_EO_UI_3118": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormFile",
		dndCompRef: "Dnd_SgiFormFile_SgiFormFile",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormFileEditor",
		sgiComp: "SgiFormUpload",
		sgiCompEO: SgiFormFileEO,
	},
	// CASCADER: "EP_EO_UI_3122",
	"EP_EO_UI_3122": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormCascader",
		dndCompRef: "Dnd_SgiFormCascader_SgiFormCascader",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiFormCascaderEditor",
		sgiComp: "SgiFormCascader",
		sgiCompEO: SgiFormCascaderEO,
	},
	// LIST: "EP_EO_UI_4107",
	"EP_EO_UI_4107": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiList",
		dndCompRef: "Dnd_SgiList_SgiList",
		dndCompEditor: "Dnd_SgiListEditor",
		sgiComp: "SgiList",
		sgiCompEO: SgiListEO,
	},
	// LT_ROW: "EP_EO_UI_5101",
	"EP_EO_UI_5101": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiRow",
		dndCompRef: "Dnd_SgiRow_SgiRow",
		dndCompEditor: "Dnd_SgiRowEditor",
		sgiComp: "SgiRow",
		sgiCompEO: SgiRowEO,
	},
	// LT_COL: "EP_EO_UI_5102",
	"EP_EO_UI_5102": {
		_type: "ctn",
		dndCompKey: "Dnd_SgiCol",
		dndCompRef: "Dnd_SgiCol_SgiCol",
		dndCompEditor: "Dnd_SgiColEditor",
		sgiComp: "SgiCol",
		sgiCompEO: SgiColEO,
	},

	// Tile: "EP_EO_UI_SgiTile",
	"EP_EO_UI_SgiTile": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiTile",
		dndCompRef: "Dnd_SgiTile_SgiTile",
		dndCompExp: "平铺组件，请填写自定义子组件渲染方法",
		dndCompEditor: "Dnd_SgiTileEditor",
		sgiComp: "SgiTile",
		sgiCompEO: SgiTileEO,
	},
	// CommEcharts: "EP_EO_UI_SgiCommEcharts",
	"EP_EO_UI_SgiCommEcharts": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiCommEcharts",
		dndCompRef: "Dnd_SgiCommEcharts_SgiCommEcharts",
		dndCompExp: "通用图表，请填写自定义option方法",
		dndCompEditor: "Dnd_SgiCommEchartsEditor",
		sgiComp: "SgiCommEcharts",
		sgiCompEO: SgiCommEchartsEO,
	},

	// 新增组件
	// Calendar: "EP_EO_UI_SgiCalendar",
	"EP_EO_UI_SgiCalendar": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiCalendar",
		dndCompRef: "Dnd_SgiCalendar_SgiCalendar",
		dndCompEditor: "Dnd_SgiCalendarEditor",
		sgiComp: "SgiCalendar",
		sgiCompEO: SgiCalendarEO,
	},
	// TINYMCE: "EP_EO_UI_TinyMCE",
	"EP_EO_UI_TinyMCE": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiFormTinyMCE",
		dndCompRef: "Dnd_SgiTinyMCE_SgiTinyMCE",
		dndSourceType: "Dnd_SgiFormCtl",
		dndCompEditor: "Dnd_SgiTinyMCEEditor",
		sgiComp: "SgiTinyMCE",
		sgiCompEO: SgiTinyMCEEO,
	},
	// CODEMIRROR: "EP_EO_UI_CODEMIRROR",
	"EP_EO_UI_CODEMIRROR": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiCodemirror",
		dndCompRef: "Dnd_SgiCodemirror_SgiCodemirror",
		dndSourceType: "Dnd_SgiCodeMirror",
		dndCompEditor: "Dnd_SgiCodeMirrorEditor",
		sgiComp: "SgiCodeMirror",
		// sgiCompEO: SgiCodeMirrorEO,
	},
	// JSONEDITOR: "EP_EO_UI_JSONEDITOR",
	"EP_EO_UI_JSONEDITOR": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiJsoneditor",
		dndCompRef: "Dnd_SgiJsoneditor_SgiJsoneditor",
		dndSourceType: "Dnd_SgiJsoneditor",
		dndCompEditor: "Dnd_SgiJsoneditorEditor",
		sgiComp: "SgiJsoneditor",
		sgiCompEO: SgiJsoneditorEO,
	},
	// ECharts
	// EC_COMMON: "EP_EO_UI_EC0001",
	"EP_EO_UI_EC0001": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiEChartsCommon",
		dndCompRef: "Dnd_SgiEChartsCommon_SgiEChartsCommon",
		dndCompExp: "ECharts图表，请填写自定义option方法",
		dndCompEditor: "Dnd_SgiEChartsCommonEditor",
		sgiComp: "SgiEChartsCommon",
		sgiCompEO: SgiEChartsCommonEO,
	},
	// G6
	// G6_COMMON: "EP_EO_UI_G60001",
	"EP_EO_UI_G60001": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiG6Common",
		dndCompRef: "Dnd_SgiG6Common_SgiG6Common",
		dndCompEditor: "_prmEditor",
		sgiComp: "SgiG6Common",
		sgiCompEO: SgiG6CommonEO,
	},
	"EP_EO_UI_DV": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiDV",
		dndCompRef: "Dnd_SgiDV_SgiDV",
		dndCompExp: "ECharts图表，请填写自定义option方法",
		dndCompEditor: "Dnd_SgiDVEditor",
		sgiComp: "SgiDV",
		sgiCompEO: SgiDVEO,
	},
	"EP_EO_UI_TV": {
		_type: "ctl",
		dndCompKey: "Dnd_SgiTV",
		dndCompRef: "Dnd_SgiTV_SgiTV",
		dndCompExp: "ECharts图表，请填写自定义option方法",
		dndCompEditor: "Dnd_SgiTVEditor",
		sgiComp: "SgiTV",
		sgiCompEO: SgiTVEO,
	}
};

export { AllCompGUID, getTypeName, AllDndCompInfo };



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiConstants/SgiCompConstant.js